import "./App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import Homepage from "./components/Homepage";
import Navbar from "./components/Navbar";
// import NewsLetter from './components/NewsLetter';
import Contact from "./components/Contact";
import SingleEvent from "./components/SingleEvent";
import WebinarState from "./context/webinarState";
import LoadingOverlay from "react-loading-overlay";
import ScrollToTop from "react-scroll-to-top";

function App() {
  const [loader, setloader] = useState(false);
  return (
    <LoadingOverlay
      active={loader}
      styles={{
        overlay: (base) => ({
          ...base,
          height: "100vh",
          position: "fixed",
        }),
      }}
      spinner
      text="Processing, Don't refresh or leave the page..."
    >
      <WebinarState>
        <BrowserRouter>
          <ScrollToTop
            smooth
            width="16"
            height="16"
            style={{ marginLeft: "auto", marginRight: "auto" }}
          />
          <Navbar />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route
              path="/register/:event"
              element={<SingleEvent setloader={setloader} />}
            />
            <Route
              path="/contact"
              element={<Contact setloader={setloader} />}
            />
          </Routes>
          {/* <NewsLetter setloader={setloader} /> */}
          <Footer />
        </BrowserRouter>
      </WebinarState>
    </LoadingOverlay>
  );
}

export default App;
